import { t } from 'i18next';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Menu } from 'semantic-ui-react';
import SearchFilters from '../../../components/elements/SearchFilter';
import Userbanner from '../../../components/elements/Userbanner';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { postAsync } from '../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../components/helper/downloadCSVHelper';
import ServiceTable from './ServiceTable';
import { Link } from 'react-router-dom';
import { PageHitCountApi } from '../../../shared/Helper';
import { useLocation } from 'react-use';
import { printTable } from '../../../utils/tableExportUtils';
const ServiceFYUPRegistList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [value, setvalue] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [pageCount, setPageCount] = useState(1);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [epUserID, setEpUserID] = useState(null);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);

  const body = {
    EPUserID: epUserID,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY') || '',
    dateTo: moment(dateTo).format('DD/MM/YYYY') || '',
  };

  const { pathname } = useLocation();



  const getdata = async () => {
    setIsLoad(true);
    await postAsync(`ServiceForYou/GetServiceForYouFilterList/${page}/${pageSize}`, body)
      .then((response) => {
        setIsLoad(false);
        const result = response?.data;
        setvalue(result);
        setPageCount(response?.page);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const handleSearch = async (e) => {
    e.preventDefault();
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(`ServiceForYou/GetServiceForYouFilterList/${page}/${pageSize}`, body)
      .then((response) => {
        setIsLoad(false);
        const result = response?.data;
        setPageCount(response?.page);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
        setvalue(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = value?.map((item, ii) => ({
      [t('S.No')]: ii + 1,
      [t('Project Name')]: isActive ? item.projectNameAR : item.projectNameEn,
      [t('Time')]: item.timeNow,
    }));
    downloadCSV(filteredData, 'Service For You Registration');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Service For You Registration List')}`;
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Time`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${value
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.projectNameAR : data?.projectNameEn !== '' ? data?.projectNameEn : data?.projectNameAR}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.date}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.timeNow}</td>
  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
   {
  header: t('Project Name'),
  accessor: (row) =>
    isActive
      ? row?.projectNameAR || 'N/A'
      : row?.projectNameEn
      ? row.projectNameEn
      : row?.projectNameAR || 'N/A'
}
,
  
    {
      header: t('Date'),
      accessor: (row) => row?.date || 'N/A'
    },
    {
  header: t('Time'),
  accessor: (row) => row?.timeNow || 'N/A'
}

  ];
  
  // Call the reusable print function
  printTable({
    data: value || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Service For You Registration List')}`,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID !== null) {
      getdata();
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);
  // Handle page change
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    await postAsync('ServiceForYou/GetServiceForYouFilterList/' + select + '/' + pageSize, body)
      .then((response) => {
        setvalue(response?.data);
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const columns = ['sNo', 'Project Name', 'Date', 'Time', 'Copy Link'];

  return (
    <div className="py-5 lg:py-10">
      <Userbanner />

      <div className="container-fluid ">
        <div className="row text-center justify-center">
          <div className="col-lg-11 ">
            <div className="flex justify-end   my-4">
              <Link className="items-center md:items-end" to="/ServiceForYouUPReg">
                <button className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center">
                  {t('create')}
                </button>
              </Link>
            </div>
          </div>
        </div>

        <div className="row  justify-center">
          <SearchFilters
            handleSearch={handleSearch}
            setDateFrom={setDateFrom}
            setDateTo={setDateTo}
            dateTo={dateTo}
            dateFrom={dateFrom}
            handlePrint={handlePrint}
            handleOnExport={handleOnExport}
            heading={'Service For You Registration List'}
          />

          <div className="col-lg-11 pt-9 ">
            <ServiceTable
              handlePageChange={handlePageChange}
              page={page}
              pageSize={pageSize}
              handlePageSizeChange={handlePageSizeChange}
              columns={columns}
              value={value}
              isLoad={isLoad}
              datanotfound={datanotfound}
              next={next}
            />
            {pageCount > 0 && (
              <div className="flex flex-row px-12 mb-7 justify-between">
                <Menu pagination>
                  <Menu.Item>
                    <ReactPaginate
                      previousLabel={t('Previous')}
                      nextLabel={t('Next')}
                      pageCount={pageCount}
                      onPageChange={changePage}
                      containerClassName={'paginationButtons'}
                      previousLinkClassName={'previousButton'}
                      nextLinkClassName={'nextButton'}
                      disabledClassName={'paginationDisabled'}
                      activeClassName={'paginationActive'}
                    />
                  </Menu.Item>
                </Menu>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceFYUPRegistList;
